
const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const { OKInput } = require('commonsComponents/OKInput');
const { BrokerMiFIDBehaviorIgnoringPreviousResults } = require('mifid/components/brokerMiFIDBehaviorIgnoringPreviousResults/brokerMiFIDBehaviorIgnoringPreviousResults');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { 
    FIRST_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_CHANGE,
    BROKER_MIFID_VERSION_2,
    BROKER_CORPORATE_OPERATIONS_CHANGE_URL,
    BROKER_CORPORATE_OPEATIONS_MIFID_ID,
    BROKER_CORPORATE_OPERATIONS_URL,
    HYPHEN
} = require('constants/index');
const CLASS_NAME = 'broker-stocks-sale-order-step1';

// @commons

class BrokerRequestFinancialOperationChangeStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.props.onChangeTitlesAmount(event.target.value);
    }

    wrapContentWithMifid(content) {
        const { 
            immBrokerRequestFinancialOperationChange,
            immCorporatesOperations,
            breadcrumb
        } = this.props;

        const immOperation = immCorporatesOperations.getIn([
            'selectedContract',
            'operations',
            immBrokerRequestFinancialOperationChange.get('selectedCorporateOperationIndex')
        ]);

        const productName = HYPHEN;
        const productUrl = BROKER_CORPORATE_OPERATIONS_URL;
        const continuationUrl = BROKER_CORPORATE_OPERATIONS_CHANGE_URL;
        const productIsin = immOperation ? immOperation.get('isin') : '';
        const productIso = immOperation ? immOperation.get('iso') : '';
        const feeNumbers = immBrokerRequestFinancialOperationChange.getIn(['steps', FIRST_STEP, 'titlesAmount']);
        const valueCode = immOperation ? immOperation.get('linkId') : undefined;
        const eventCode = immOperation ? immOperation.get('eventCode') : undefined;
        const mifidOptions = {
            operationType: BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_CHANGE,
            operationData: immBrokerRequestFinancialOperationChange.toJS(),
            breadcrumb: breadcrumb
        };

        return (
            <BrokerMiFIDBehaviorIgnoringPreviousResults
                mifidVersion={BROKER_MIFID_VERSION_2}
                displayWhileLoading={false}
                productName={productName}
                productUrl={productUrl}
                continuationUrl={continuationUrl}
                productIsinId={productIsin}
                productMarketId={productIso}
                productMifidId={BROKER_CORPORATE_OPEATIONS_MIFID_ID}
                feeNumbers={feeNumbers}
                valueCode={valueCode}
                eventCode={eventCode}
                mifidOptions={mifidOptions}
                cancelPath={productUrl}
            >
                {content}
            </BrokerMiFIDBehaviorIgnoringPreviousResults>
        );
    }

    buildContent() {
        const {immBrokerRequestFinancialOperationChange} = this.props;
        const immFirstStep = immBrokerRequestFinancialOperationChange.getIn(['steps', FIRST_STEP]);
        const titlesAmountLabel = formatText('requestFinancialOperationChange-titlesAmount');
        const titlesAmount = immFirstStep.get('titlesAmount');
        const isAmountOfTitlesError = immFirstStep.get('isAmountOfTitlesError');

        return (
            <div>
                <h4 className={`${CLASS_NAME}__header-title`}>
                    <FormattedText
                        value="requestFinancialOperationChange-titleHeaderStep1"
                    />
                </h4>
                <div className={`${CLASS_NAME}__info`}>
                    <FormattedText
                        value="requestFinancialOperationChange-titleSubHeaderStep1"
                    />
                </div>
                <div className={`${CLASS_NAME}__field`}>
                    <div className={`${CLASS_NAME}__input`}>
                        <span className={`${CLASS_NAME}__titles`}>
                            {titlesAmountLabel}
                        </span>
                    </div>
                    <OKInput value={titlesAmount} onChange={this.handleChange}
                        errorState={isAmountOfTitlesError}
                        errorMessage={formatText('corporatesOperations-titlesAmountError')}
                    />
                </div>
            </div>
        );
    }

    buildContentWithMifidIfRequired() {
        const { immBrokerRequestFinancialOperationChange } = this.props;
        const mustRunMifid = immBrokerRequestFinancialOperationChange.getIn(['steps', FIRST_STEP, 'mustRunMifid']);
        const content = this.buildContent();

        if (mustRunMifid) {
            return this.wrapContentWithMifid(content);
        } else {
            return this.buildContent();
        }
    }

    render() {
        return this.buildContentWithMifidIfRequired();
    }
}

BrokerRequestFinancialOperationChangeStep1.propTypes = {
    immBrokerRequestFinancialOperationChange: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    onChangeTitlesAmount: PropTypes.func.isRequired,
    breadcrumb: PropTypes.object.isRequired
};

module.exports = BrokerRequestFinancialOperationChangeStep1;